module.exports = __webpack_public_path__ + "img/pwrlab_wordmark.e08198a6.png";